import gql from 'graphql-tag';

export const GetLaunchDarklyFlag = gql`
  query LaunchDarklyFlag($customerId: String!, $country: String, $flagName: String!) {
    LaunchDarklyFlag(customerId: $customerId, country: $country, flagName: $flagName) {
      response
    }
  }
`;
